module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBd.woff?v=fe6a634a1db08e227abfc09c1a0eac75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBd.woff
// module id = 675
// module chunks = 0